import React, { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { MdEditNote } from 'react-icons/md';
import AppURL from '../../../../widgets/AppURL';
import { fetchDataFromApi } from '../../../../widgets/api';
import { NextBtn, PrevBtn } from '../../../../widgets/AppBtn';

const LibraryBookList = ({ bookEditedList, onSelectBooks, editBook, setEditedDetails, selectedBookIds = [], BookAddOptionListView }) => {
  const [selectAll, setSelectAll] = useState(false);

  const totalCount = bookEditedList?.results?.length ?? 0;

  // const handleCheck = (bookId) => {
  //   const newSelected = selectedBookIds.includes(bookId)
  //     ? selectedBookIds.filter((id) => id !== bookId)
  //     : [...selectedBookIds, bookId];
  //   onSelectBooks(bookId);
  //   setSelectAll(newSelected.length === totalCount && totalCount > 0);
  // };

  // const handleSelectAll = () => {
  //   if (selectAll) {
  //     onSelectBooks([]);
  //     setSelectAll(false);
  //   } else {
  //     const allIds = bookEditedList?.results?.map((book) => book.book_id) || [];
  //     onSelectBooks(allIds);
  //     setSelectAll(true);
  //   }
  // };

  const isIndeterminate = selectedBookIds.length > 0 && selectedBookIds.length < totalCount;

  return (
    <div className="bg-white rounded-sm font-sans">
      {/* Toolbar */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">
            Book List
          </span>
          {totalCount > 0 && (
            <span className="text-xs bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-200 px-2 py-0.5 rounded-full font-medium">
              {totalCount} records
            </span>
          )}
        </div>

        <div className="flex items-center gap-2">
          {selectedBookIds.length > 0 && (
            <span className="text-xs text-gray-900 dark:text-gray-400">
              {selectedBookIds.length} selected
            </span>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-xs">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-700">
              {/* <th className="sticky top-0 z-10 bg-gray-50 dark:bg-gray-700 px-3 py-2.5 text-left">
                <input
                  type="checkbox"
                  ref={(el) => {
                    if (el) el.indeterminate = isIndeterminate;
                  }}
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="w-4 h-4 text-blue-600 rounded border-gray-300 dark:border-gray-500 cursor-pointer focus:ring-blue-500"
                  title={selectAll ? 'Deselect all' : 'Select all'}
                />
              </th> */}
              {['ID', 'Book Name', 'Author', 'Publisher', 'Edition', 'Actual Price', 'Life %', 'Action'].map(
                (col) => (
                  <th
                    key={col}
                    className="sticky top-0 z-10 bg-gray-50 dark:bg-gray-700 px-3 py-1.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 capitalize tracking-wider whitespace-nowrap"
                  >
                    {col}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700 bg-white dark:bg-slate-800">
            {bookEditedList?.results?.length > 0 ? (
              bookEditedList.results.map((book) => {
                // const isSelected = selectedBookIds.includes(book.book_id);
                return (
                  <tr
                    key={book.book_id}
                    // onClick={() => handleCheck(book.book_id)}
                    className={`cursor-pointer transition-colors duration-100 ${book.book_id === selectedBookIds
                      ? 'bg-blue-50 dark:bg-blue-900/20'
                      : 'hover:bg-gray-50 dark:hover:bg-gray-700/40'
                      }`}
                  >
                    {/* <td className="px-3 py-1" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleCheck(book.book_id)}
                        className="w-4 h-4 text-blue-600 rounded border-gray-300 dark:border-gray-500 cursor-pointer focus:ring-blue-500"
                      />
                    </td> */}
                    <td className="px-3 py-1 text-gray-500 dark:text-gray-400 font-mono">
                      {book.book_id}
                    </td>
                    <td className="px-3 py-1 text-gray-900 dark:text-white font-medium max-w-[160px] truncate" title={book.book_name}>
                      {book.book_name}
                    </td>
                    <td className="px-3 py-1 text-gray-700 dark:text-gray-300 max-w-[120px] truncate" title={book.book_author}>
                      {book.book_author}
                    </td>
                    <td className="px-3 py-1 text-gray-700 dark:text-gray-300 max-w-[120px] truncate" title={book.book_publisher}>
                      {book.book_publisher}
                    </td>
                    <td className="px-3 py-1 text-gray-700 dark:text-gray-300">{book.edition}</td>
                    <td className="px-3 py-1 text-gray-700 dark:text-gray-300">
                      {book.actual_price ?? book.orginal_price}
                    </td>
                    <td className="px-3 py-1">
                      <span
                        className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${book.life_percent >= 75
                          ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                          : book.life_percent >= 40
                            ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                            : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                          }`}
                      >
                        {book.life_percent}%
                      </span>
                    </td>
                    <td className="px-3 py-1" onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={() => {editBook(book.book_id);  onSelectBooks(book.book_id);}}
                        className="inline-flex items-center gap-1 px-2 py-0.5 text-xs text-blue-600 hover:text-white hover:bg-blue-600 border border-blue-200 hover:border-blue-600 rounded transition-all duration-150"
                        title="Edit book"
                      >
                        <FaEdit className="w-3 h-3" />
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="px-4 py-10 text-center text-gray-400 dark:text-gray-500">
                  No books found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <div className='flex gap-3 mt-3 justify-end'>
                      <PrevBtn disabled={bookEditedList?.previous === null ? true : false} onClick={async () => {
                          if (bookEditedList?.previous) {
                              await BookAddOptionListView(bookEditedList?.previous)
                          }
                      }} />
                      <NextBtn disabled={bookEditedList?.next === null ? true : false} onClick={async () => {
                          if (bookEditedList?.next) {
                              await BookAddOptionListView(bookEditedList?.next)
                          }
                      }} />
                  </div>
     
    </div>
  );
};

export default LibraryBookList;